import { createSlice } from '@reduxjs/toolkit';

const sliceChatbot = createSlice({
  name: 'chatbot',
  initialState: {
    urls: [],
    description: '',
    show: true,
  },
  reducers: {
    setUrls(state, action) {
      state.urls = [...state.urls, ...action.payload];
    },
    setDescription(state, action) {
      state.description = action.payload;
    },
    clearUrls(state) {
      state.urls = [];
    },
    setShow(state, action) {
      state.show = action.payload;
    },
  },
});

export const { setUrls, setDescription, clearUrls, setShow } = sliceChatbot.actions;

export const getUrls = state => state.chatbot.urls;
export const getDescription = state => state.chatbot.description;

export const getChatBotShow = state => state.chatbot.show;

export default sliceChatbot.reducer;
